import React, { useState, useRef } from 'react';
import axios from 'axios';

const HospitalQRView = ({ hospitalQR, loading, error, generateHospitalQR }) => (
  <div className="p-6 bg-white rounded-lg shadow-lg">
    <h2 className="text-2xl font-bold mb-4">🏥 Hospital QR Code - Registration</h2>
    <p className="text-gray-600 mb-4">Patients अपने mobile से यह QR scan करके registration कर सकते हैं।</p>
    
    <button onClick={() => generateHospitalQR()} className="mb-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Generate QR</button>
    
    {loading && <p className="text-blue-600">Loading QR code...</p>}
    {error && <p className="text-red-600">Error: {error}</p>}
    {hospitalQR && (
      <div className="bg-gray-100 p-6 rounded-lg flex justify-center">
        <img 
          src={hospitalQR} 
          alt="Hospital QR Code" 
          className="w-64 h-64 border-4 border-blue-500"
        />
      </div>
    )}
  </div>
);

const PatientQRView = ({ patientID, setPatientID, patientQR, loading, error, generatePatientQR, success }) => (
  <div className="p-6 bg-white rounded-lg shadow-lg">
    <h2 className="text-2xl font-bold mb-4">👤 Patient QR Code - Share Data</h2>
    <p className="text-gray-600 mb-4">Patient का QR code दूसरे hospitals के doctors को भेज सकता है।</p>
    
    <div className="mb-4">
      <label className="block text-sm font-medium mb-2">Patient ID:</label>
      <input 
        type="text" 
        value={patientID}
        onChange={(e) => setPatientID(e.target.value.slice(0, 30))}
        maxLength={30}
        placeholder="patient_123"
        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-green-500"
      />
      <button onClick={() => generatePatientQR(patientID)} className="mt-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">Generate QR</button>
    </div>

    {loading && <p className="text-blue-600">Generating QR code...</p>}
    {error && <p className="text-red-600">Error: {error}</p>}
    {patientQR && (
      <div className="bg-gray-100 p-6 rounded-lg flex justify-center">
        <img 
          src={patientQR} 
          alt="Patient QR Code" 
          className="w-64 h-64 border-4 border-green-500"
        />
      </div>
    )}
    {success && <p className="text-green-600 mt-4">✅ {success}</p>}
  </div>
);

export default function ABDMQRScanner() {
  const [mode, setMode] = useState('hospital');
  const [hospitalQR, setHospitalQR] = useState(null);
  const [patientQR, setPatientQR] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [patientID, setPatientID] = useState('');
  const fileInputRef = useRef(null);

  const generateHospitalQR = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/abdm/qr/hospital`);
      setHospitalQR(response.data.qr_code);
      setSuccess('✅ Hospital QR generated!');
    } catch (err) {
      setError('Failed to generate hospital QR');
    } finally {
      setLoading(false);
    }
  };

  const generatePatientQR = async (pid) => {
    if (!pid.trim()) {
      setError('Enter Patient ID!');
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post(`/api/abdm/qr/patient`, { patient_id: pid });
      setPatientQR(response.data.qr_code);
      setSuccess('✅ Patient QR generated!');
    } catch (err) {
      setError('Failed to generate patient QR');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <button onClick={() => setMode('hospital')} className={`px-4 py-2 rounded ${mode === 'hospital' ? 'bg-blue-600 text-white' : 'bg-gray-300'}`}>🏥 Hospital QR</button>
        <button onClick={() => setMode('patient')} className={`px-4 py-2 rounded ${mode === 'patient' ? 'bg-green-600 text-white' : 'bg-gray-300'}`}>👤 Patient QR</button>
      </div>
      
      <div className={mode === 'hospital' ? 'block' : 'hidden'}>
        <HospitalQRView hospitalQR={hospitalQR} loading={loading} error={error} generateHospitalQR={generateHospitalQR} />
      </div>
      
      <div className={mode === 'patient' ? 'block' : 'hidden'}>
        <PatientQRView patientID={patientID} setPatientID={setPatientID} patientQR={patientQR} loading={loading} error={error} generatePatientQR={generatePatientQR} success={success} />
      </div>
    </div>
  );
}
